"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactAdminToUseApp = void 0;
var env_1 = require("dingtalk-jsapi/lib/env");
var openLink_1 = __importDefault(require("dingtalk-jsapi/api/biz/util/openLink"));
var openSlidePanel_1 = __importDefault(require("dingtalk-jsapi/api/biz/util/openSlidePanel"));
/**
 * @name contactAdminToUseApp
 * @category biz Helpers
 * @summary 联系管理员，开通应用或授权当前用户使用应用
 * @description
 * 唤起联系管理员界面，让管理员开通应用或授权当前用户使用应用
 * 支持小程序和H5微应用
 *
 * @param {Object} opt - 联系管理员参数配置
 * @param {String} [opt.corpId] - 组织ID
 * @param {Number|String} [opt.id] - 应用ID或模板ID
 * @param {String} [opt.type] - 类型，标识应用或模板，可选参数。值为"APP"或"TEMPLATE"，默认为"APP"
 * @returns {Promise}
 * @example
 * // 唤起联系管理员界面
 * contactAdminToUseApp({ id: 1234, corpId: 'dingxxxxxxxx', })
 */
var platform = env_1.getENV().platform;
function contactAdminToUseApp(opt) {
    var id = opt.id, _a = opt.type, type = _a === void 0 ? 'APP' : _a, corpId = opt.corpId;
    if (!corpId || !id) {
        return Promise.reject({
            error: 'params error',
            message: 'contactAdmin error: id or corpId is missing, contactAdmin({ id: \'appId\', corpId: \'corpId\'})',
        });
    }
    if (type !== 'APP' && type !== 'TEMPLATE') {
        return Promise.reject({
            error: 'params error',
            message: 'contactAdmin error: type should be "APP" or "TEMPLATE"',
        });
    }
    var url = "https://h5.dingtalk.com/open-purchase/contactAdminToUseApp.html?corpId=" + corpId + "&appEntityId=" + id + "&appEntityType=" + type;
    if (platform === env_1.ENV_ENUM.pc) {
        // PC端
        return openSlidePanel_1.default({
            url: url,
        });
    }
    // 移动端
    return openLink_1.default({ url: url, });
}
exports.contactAdminToUseApp = contactAdminToUseApp;
